import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import loadImage from "blueimp-load-image";
import { isEmpty } from "lodash";
export const sampleDocumentsToRealDocuments = (sampleDocuments = []) => {
  return _mapInstanceProperty(sampleDocuments).call(sampleDocuments, sampleDocument => {
    return _objectSpread(_objectSpread({}, sampleDocument), {}, {
      comments: [],
      documentStatus: "active",
      isSample: true,
      requestClassification: sampleDocument.classificationType,
      requestCreatedAt: "",
      requestStatus: "outstanding",
      requestUpdatedAt: "",
      requestedAt: "",
      sent: false
    });
  });
};
export const getLatestSubmissionPerLender = submissions => {
  var _context;
  if (isEmpty(submissions.byId)) return [];
  const allSubmissions = _mapInstanceProperty(_context = submissions.allIds).call(_context, submissionId => submissions.byId[submissionId]);
  return _Object$values(_reduceInstanceProperty(allSubmissions).call(allSubmissions, (acc, submission) => {
    if (!acc[submission.lenderName] || new Date(acc[submission.lenderName].createdAt) < new Date(submission.createdAt)) {
      acc[submission.lenderName] = submission;
    }
    return acc;
  }, {}));
};
export const rotateFileIfNeeded = async file => {
  var _context2;
  return !_includesInstanceProperty(_context2 = file.type).call(_context2, "image") ? file.data : await (async () => {
    const {
      image
    } = await loadImage(file.data, {
      orientation: true,
      canvas: true
    });
    const dataURL = image.toDataURL(file.type);
    const blob = await (await fetch(dataURL)).blob();
    return new File([blob], file.fileName, {
      type: file.type
    });
  })();
};